import React from 'react';
import { Grid, GridItem, Text, Box, Button } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import DeliveryAddress from './DeliveryAddress';
import BillingAddress from './BillingAddress';

export default function ConfirmAddresses() {
  const isMobile = useSelector((state) => state.gym.isMobile);
  return (
    <Grid
      templateColumns={{ base: '1fr', md: '1fr 1fr' }} // Define two equal columns
      columnGap={'2vw'} // No gap between columns
      width="100%"
      padding={{ base: '0 2vw', md: '0 2vw' }}
    >
      <GridItem colSpan={1} height="100%" padding={{ base: '6vw 0', md: '0' }}>
        <DeliveryAddress addressType="delivery" />
      </GridItem>
      <GridItem colSpan={1} height="100%">
        <BillingAddress addressType="billing" />
      </GridItem>
    </Grid>
  );
}
